import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/home/Hero';
import { MethodSection } from '../components/home/MethodSection';
import { LessonsSection } from '../components/home/LessonsSection';
import { WorkshopsSection } from '../components/home/WorkshopsSection';
import { HealthSection } from '../components/home/HealthSection';
import { Testimonial } from '../components/home/Testimonial';
import { ContactSection } from '../components/home/ContactSection';
import { SiteFooter } from '../components/SiteFooter';
export function Home() {
  return <div className="min-h-screen w-full bg-paper text-ink" data-id="element-140" data-mp="29gdeypdzagd3">
      <SiteHeader data-id="element-141" data-mp="29i7ybz9lq0f2" />
      <main data-id="element-142" data-mp="2dhqigstlm7gu">
        <Hero data-id="element-143" data-mp="2dhgtn8kai6cq" />
        <MethodSection data-id="element-144" data-mp="2dhyw4mxjpgt3" />
        <LessonsSection data-id="element-145" data-mp="2dii6nikv92x3" />
        <WorkshopsSection data-id="element-146" data-mp="2dfm5lldq1y4f" />
        <HealthSection data-id="element-147" data-mp="3kvk4igsu2v4e" />
        <Testimonial data-id="element-148" data-mp="3ku8qzp9l6903" />
        <ContactSection data-id="element-149" data-mp="3kuqun6ykvpi1" />
      </main>
      <SiteFooter data-id="element-150" data-mp="3owvljxxn680z" />
    </div>;
}